module.exports = __webpack_public_path__ + "static/bringing-soldiers-home-09f0d35a0d7a61334e4febe3f2c47f47.jpg";